import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import './index.scss'
import { getableHandler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {message} from "antd";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.getListData();
  }


  state = {
    dataSource: [],
    tips:'',
    loading: true,

  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const url = '/'+localStorage.getItem('api')
    getableHandler(url).then(res=>{
      if (res.statecode === 0) {
        let data =JSON.parse(JSON.stringify(res.records))
        this.setState({
          dataSource: data,
          tips:data.length==0?'暂无数据':'',
          loading: false
        });
      } else {
        this.setState({
          loading: false,
          tips:res.statemessage
        });
      }
      let data =JSON.parse(JSON.stringify(res.records))
      this.setState({
        dataSource: data,
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    console.log(99999);
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          {this.state.dataSource.length > 0 ?
              this.state.dataSource.map((item,index)=>{
                  return(
                      <div>
                        {index === 0?
                            <h2>{item.title}</h2>:
                            <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                        }
                        {
                          item.datalist.map((item,index1)=>{
                            return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                              {
                                item.map(item2=>{
                                  return (
                                      <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                                  )
                                })
                              }
                            </div>)
                          })
                        }
                      </div>
                  )
                }):
              this.state.tips
          }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
